import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NgForm, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss', '../../../assets/form.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CaptchaComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CaptchaComponent),
      multi: true
    },
  ]
})
export class CaptchaComponent implements OnInit, ControlValueAccessor, Validator {

  generatedCaptcha: string;
  private _captchaInput: string;
  public get captchaInput(): string {
    return this._captchaInput;
  }
  public set captchaInput(value: string) {
    this._captchaInput = value;
    this.onChange(value);
    this.onTouch(value);
    // this.onValidatorChange()

  }

  @Input('form') form: NgForm;

  constructor() { }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  writeValue(obj: any): void {
    // this.captchaInput = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  validate(control: AbstractControl): ValidationErrors {

    const validCaptcha = this.validCaptcha();
    const error = control.value && validCaptcha ? null : { invalidCaptcha: true };
    return error;
  }

  onChange: any = (c) => {
  }
  onTouch: any = (t) => {
  }
  onValidatorChange: any = (t) => {
  }


  ngOnInit(): void {
    this.generateCaptcha();
  }

  generateCaptcha() {
    const alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
      'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9');
    const arr = [];
    for (let i = 0; i < 6; i++) {
      arr.push(alpha[Math.floor(Math.random() * alpha.length)]);
    }
    const code = arr.join(' ');
    this.generatedCaptcha = code;
  }
  private validCaptcha() {
    const string1 = this.removeSpaces(this.generatedCaptcha);
    const string2 = this.removeSpaces(this.captchaInput);
    return string1.toLowerCase() == string2.toLowerCase();
  }
  private removeSpaces(string) {
    if (!string) {
      return ''
    }
    return string.split(' ').join('');
  }
}
